export const ACCOUNT_NAME = 'wix-platform'
export const NAMESPACE = 'blog-cross-posts'

export const API_URL_SUFFIX = `_functions/@${ACCOUNT_NAME}/${NAMESPACE}-backend`

export const POST_ENDPOINT = 'postGist'
export const POSTS_ENDPOINT = 'postsGist'
export const AUTHOR_ADD_SUBDOMAIN_ENDPOINT = 'authorAddSubdomain'

export const COLLECTIONS_ID_PREFIX = `@${ACCOUNT_NAME}/${NAMESPACE}/`
export const POSTS_COLLECTION_ID = `${COLLECTIONS_ID_PREFIX}Posts`
export const AUTHORS_COLLECTION_ID = `${COLLECTIONS_ID_PREFIX}authors`
export const BLOGS_COLLECTION_ID = `${COLLECTIONS_ID_PREFIX}Blogs`

export const AUTHOR_URL_PATH = 'author'